export default function TikTokIcon({ size = 24 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width={size} height={size} aria-hidden="true">
      <path d="M16.6 2h-3.2v13.6a2.8 2.8 0 1 1-2-2.68V9.6a5.99 5.99 0 1 0 5.2 5.94V8.34a7.7 7.7 0 0 0 4.4 1.38V6.5a4.6 4.6 0 0 1-4.4-4.5Z" />
    </svg>
  )
}
